import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { minLength } from '@adornis/validation/functions/length.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Validator } from '@adornis/validation/validator.js';
import type { Taetigkeiten } from '@martinus/taetigkeit/enums/Taetigkeiten.js';
import { KostenstelleProzentsatz } from './KostenstelleProzentsatz.js';

/**
 * @entity AGVertragsInfos
 *
 * Is the general information for a Eingruppierung
 */
@Entity()
export class AGVertragsInfos extends AdornisEntity {
  static override _class = 'AGVertragsInfos';

  @Field(() => Date)
  startDate: Maybe<Date>;

  @Field(() => Date)
  endDate: Maybe<Date>;

  @Field(() => [KostenstelleProzentsatz], { default: v => v ?? [] })
  kostenstelleProzentsaetze: Maybe<KostenstelleProzentsatz[]>;

  @Field(() => String)
  taetigkeit!: Taetigkeiten;

  @Field(() => String)
  taetigkeitsschluessel: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  zeitarbeitsverhaeltnis: Maybe<boolean>;

  @Field(() => String)
  stellenbezeichnung: Maybe<string>;

  @Field(() => Date)
  endeProbezeit: Maybe<Date>;

  @Field(() => String)
  sachkontenzuordnung: Maybe<string>;
}

if (A.isClient) {
  AGVertragsInfos.prototype.validator = new Validator({
    taetigkeit: nonOptional(),
    kostenstelleProzentsaetze: minLength(1),
  });
}
